import { ConfigProvider, DatePicker } from 'antd';
import { FC } from 'react';
import 'dayjs/locale/ru';
import locale from 'antd/lib/date-picker/locale/ru_RU';
import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';

import { Field, ControlSize, controlSizeClasses } from '../field';
import { colorToken } from '../tokens';

const CalendarIcon = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" className="text-ink" aria-hidden>
    <path
      d="M2.5 9.46354H17.5M14.1667 2.79688V6.13021M5.83333 2.79688V6.13021M14.1667 4.46354H5.83333C4.94928 4.46354 4.10143 4.81473 3.47631 5.43985C2.85119 6.06497 2.5 6.91282 2.5 7.79687V15.0885C2.5 15.9726 2.85119 16.8204 3.47631 17.4456C4.10143 18.0707 4.94928 18.4219 5.83333 18.4219H14.1667C15.0507 18.4219 15.8986 18.0707 16.5237 17.4456C17.1488 16.8204 17.5 15.9726 17.5 15.0885V7.79687C17.5 6.91282 17.1488 6.06497 16.5237 5.43985C15.8986 4.81473 15.0507 4.46354 14.1667 4.46354Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DatePickerCustom: FC<{
  /** `YYYY-MM-DD`. */
  date?: string;
  /** Receives `YYYY-MM-DD`. */
  setDate: (date: string) => void;
  label?: string;
  required?: boolean;
  disabledDate?: (current: Dayjs) => boolean;
  disabled?: boolean;
  size: ControlSize;
  invalid?: boolean;
}> = ({ setDate, label, date, required, disabledDate, disabled, size, invalid }) => {
  return (
    <Field size={size} label={label} required={required} invalid={invalid}>
      <ConfigProvider
        theme={{
          token: { colorPrimary: colorToken('primary'), colorLink: colorToken('ink') },
          components: {
            DatePicker: {
              // Scoped to the field: a global `fontSize` or `borderRadius` would restyle the calendar popup too.
              // antd takes one number, not a breakpoint: `sm` stays 14px on phones too.
              inputFontSize: size === 'sm' ? 14 : 16,
              // Same border and focus as `controlClasses` in ../field — antd takes colours, not classes.
              colorBorder: invalid ? colorToken('danger') : colorToken('line-strong'),
              hoverBorderColor: invalid ? colorToken('danger') : colorToken('line-strong'),
              activeBorderColor: colorToken('primary'),
              activeShadow: `0 0 0 1px ${colorToken('primary')}`,
            },
          },
        }}
      >
        <DatePicker
          className={classNames('w-full rounded-control !font-sans', controlSizeClasses[size])}
          value={date ? dayjs(date) : undefined}
          placeholder="01.01.2000"
          disabled={disabled}
          onChange={(_, val) => {
            setDate(
              typeof val === 'string' ? val.split('.').reverse().join('-') : val[0].split('.').reverse().join('-'),
            );
          }}
          locale={locale}
          format={'DD.MM.YYYY'}
          disabledDate={disabledDate}
          suffixIcon={<CalendarIcon />}
        />
      </ConfigProvider>
    </Field>
  );
};
